import { Button, ButtonGroup, Text } from "@shopify/polaris"
import { XIcon } from "@shopify/polaris-icons"
import { ReactNode, useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"

import styles from "./index.module.scss"

type EditorPopupProps = {
  open: boolean
  active: boolean
  title?: string
  children?: ReactNode
  primaryAction?: {
    content?: string,
    onAction: () => void | boolean,
  }
  secondaryActions?: {
    content?: string,
    onAction: () => void,
  }
  close: () => void
  /** X 按钮专用回调，未提供时回退到 close */
  onDismiss?: () => void
}
const EditorPopup = (props: EditorPopupProps) => {
  const { t } = useTranslation("email_edit")
  const { title, active, close, onDismiss, open, children, primaryAction, secondaryActions } = props
  const containerRef = useRef<HTMLDivElement>(null)

  // 弹出时锁定滚动：弹层是 absolute inset:0，页面或所在滚动容器一滚动就会把它带出可视区
  useEffect(() => {
    if (!open) return

    const locked: [HTMLElement, string][] = [[document.body, document.body.style.overflow]]

    let node = containerRef.current?.parentElement

    while (node && node !== document.body) {
      const { overflowY } = getComputedStyle(node)

      if ((overflowY === "auto" || overflowY === "scroll") && node.scrollHeight > node.clientHeight) {
        locked.push([node, node.style.overflow])
      }

      node = node.parentElement
    }

    locked.forEach(([el]) => { el.style.overflow = "hidden" })

    return () => {
      locked.forEach(([el, original]) => { el.style.overflow = original })
    }
  }, [open])

  return !open ? null : <div className={styles.popupContainer} ref={containerRef}>
    <div className={styles.header}>
      <Text variant={"headingMd"} as={"h3"}>{title}</Text>
      <Button icon={XIcon} onClick={onDismiss ?? close} variant={"tertiary"} />
    </div>

    <div className={styles.main}>
      {children}
    </div>

    <div className={styles.footer}>
      <ButtonGroup>
        <Button onClick={() => {
          secondaryActions ? secondaryActions.onAction() : null
          close()
        }}
        >{secondaryActions && secondaryActions.content || t("Cancel")}</Button>

        {
          primaryAction &&
          <Button
            disabled={!active}
            onClick={() => {
              const result = primaryAction ? primaryAction.onAction() : null

              // result 验证失败, 不关闭窗口
              if (result !== false) close()

            }}

            variant="primary"
          >{primaryAction.content || t("Done")}</Button>
        }
      </ButtonGroup>
    </div>
  </div>
}

export default EditorPopup
